<template>
  <div>
    <surveys-table
      surveyName="TOPAS"
      surveyCode="TOPAS"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_TOPAS,
        viewDetail: permissions.SEE_DETAIL_SURVEY_TOPAS,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
